var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5698 2.79108C18.1087 2.32976 17.5612 1.9638 16.9587 1.71413C16.3561 1.46445 15.7102 1.33594 15.058 1.33594C14.4057 1.33594 13.7598 1.46445 13.1573 1.71413C12.5547 1.9638 12.0072 2.32976 11.5461 2.79108L10.5891 3.74804L9.63219 2.79108C8.70078 1.85968 7.43753 1.33642 6.12033 1.33642C4.80313 1.33642 3.53987 1.85968 2.60847 2.79108C1.67707 3.72248 1.15381 4.98574 1.15381 6.30294C1.15381 7.62014 1.67707 8.8834 2.60847 9.8148L3.56543 10.7718L10.5891 17.7955L17.6129 10.7718L18.5698 9.8148C19.0311 9.35369 19.3971 8.80621 19.6468 8.20364C19.8965 7.60106 20.025 6.9552 20.025 6.30294C20.025 5.65068 19.8965 5.00482 19.6468 4.40224C19.3971 3.79967 19.0311 3.25219 18.5698 2.79108V2.79108Z",
    stroke: "#4676FA",
    strokeWidth: 1.80558,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.aa513d75e338e77163501752e9b916b6.svg";
export { ForwardRef as ReactComponent };